module.exports = __webpack_public_path__ + "static/media/german_luftwaffe_flak_120.96edb01d.png";